type LoggableTypes = Error | string | number | object | number;

// eslint-disable-next-line no-console
export const devError = (obj: LoggableTypes | Array<LoggableTypes>): void => console.error(obj);
